import { Plugin, PluginKey } from '@tiptap/pm/state';

const EditorContentPlugin = new Plugin({
  key: new PluginKey('EditorContent'),
  props: {
    attributes: {
      spellcheck: 'false',
      translate: 'no',
    },
  },
});

export default EditorContentPlugin;
